export interface Village {
  id: string;
  name: string;
  district: string;
}

// רשימת יישובים בצפון ישראל - מחוז הצפון בלבד
export const NORTH_ISRAEL_VILLAGES: Village[] = [
  // ערים מרכזיות
  { id: 'haifa', name: 'חיפה', district: 'חיפה' },
  { id: 'nazareth', name: 'נצרת', district: 'הצפון' },
  { id: 'nof-hagalil', name: 'נוף הגליל', district: 'הצפון' },
  { id: 'acre', name: 'עכו', district: 'הצפון' },
  { id: 'tiberias', name: 'טבריה', district: 'הצפון' },
  { id: 'safed', name: 'צפת', district: 'הצפון' },
  { id: 'carmiel', name: 'כרמיאל', district: 'הצפון' },
  { id: 'nahariya', name: 'נהריה', district: 'הצפון' },
  { id: 'kiryat-shmona', name: 'קריית שמונה', district: 'הצפון' },
  { id: 'maalot-tarshiha', name: 'מעלות-תרשיחא', district: 'הצפון' },
  { id: 'kiryat-ata', name: 'קריית אתא', district: 'חיפה' },
  { id: 'kiryat-bialik', name: 'קריית ביאליק', district: 'חיפה' },
  { id: 'kiryat-motzkin', name: 'קריית מוצקין', district: 'חיפה' },
  { id: 'kiryat-yam', name: 'קריית ים', district: 'חיפה' },
  
  // יישובים ערביים
  { id: 'shfaram', name: 'שפרעם', district: 'הצפון' },
  { id: 'sakhnin', name: 'סח\'נין', district: 'הצפון' },
  { id: 'tamra', name: 'טמרה', district: 'הצפון' },
  { id: 'arabeh', name: 'עראבה', district: 'הצפון' },
  { id: 'deir-hanna', name: 'דייר חנא', district: 'הצפון' },
  { id: 'majd-al-krum', name: 'מג\'ד אל-כרום', district: 'הצפון' },
  { id: 'kabul', name: 'כאבול', district: 'הצפון' },
  { id: 'ibillin', name: 'אעבלין', district: 'הצפון' },
  { id: 'bir-al-maksur', name: 'בוסמת טבעון', district: 'הצפון' },
  { id: 'yafa-an-naseriyye', name: 'יפיע', district: 'הצפון' },
  { id: 'reineh', name: 'ריינה', district: 'הצפון' },
  { id: 'kafr-kanna', name: 'כפר כנא', district: 'הצפון' },
  { id: 'kafr-manda', name: 'כפר מנדא', district: 'הצפון' },
  { id: 'turan', name: 'טורעאן', district: 'הצפון' },
  { id: 'baqa-al-gharbiyye', name: 'באקה אל-גרבייה', district: 'חיפה' },
  { id: 'umm-al-fahm', name: 'אום אל-פחם', district: 'חיפה' },
  { id: 'kafr-qasim', name: 'כפר קאסם', district: 'חיפה' },
  { id: 'jisr-az-zarqa', name: 'ג\'סר א-זרקא', district: 'חיפה' },
  { id: 'daliyat-al-karmel', name: 'דלית אל-כרמל', district: 'חיפה' },
  { id: 'usifiya', name: 'עוספיה', district: 'חיפה' },
  { id: 'shibli', name: 'שיבלי', district: 'הצפון' },
  { id: 'uzair', name: 'עוזיר', district: 'הצפון' },
  { id: 'rumana', name: 'רומאנה', district: 'הצפון' },
  { id: 'bueine', name: 'בועיינה', district: 'הצפון' },
  { id: 'ramat-yishay', name: 'רמת הייב', district: 'הצפון' },
  { id: 'nujidat', name: 'נוג\'ידאת', district: 'הצפון' },
  { id: 'ein-mahel', name: 'עין מאהל', district: 'הצפון' },
  { id: 'ilut', name: 'עילוט', district: 'הצפון' },
  { id: 'iksal', name: 'אכסאל', district: 'הצפון' },
  { id: 'eilabun', name: 'עילבון', district: 'הצפון' },
  { id: 'arara', name: 'ערערה', district: 'הצפון' },
  { id: 'kafr-yasif', name: 'כפר יאסיף', district: 'הצפון' },
  { id: 'jadeidi-makr', name: 'ג\'דיידה-מכר', district: 'הצפון' },
  { id: 'abu-snan', name: 'אבו סנאן', district: 'הצפון' },
  { id: 'mughar', name: 'מוגר', district: 'הצפון' },
  { id: 'buqata', name: 'בוקעאתא', district: 'הצפון' },
  { id: 'masada', name: 'מסעדה', district: 'הצפון' },
  { id: 'majd-al-shams', name: 'מג\'דל שמס', district: 'הצפון' },
  { id: 'kafr-qara', name: 'כפר קרע', district: 'הצפון' },
  { id: 'basmat-tivon', name: 'בסמת טבעון', district: 'הצפון' },
  { id: 'zarzir', name: 'זרזיר', district: 'הצפון' },
  
  // יישובים דרוזים
  { id: 'peki\'in', name: 'פקיעין', district: 'הצפון' },
  { id: 'hurfeish', name: 'חורפיש', district: 'הצפון' },
  { id: 'julis', name: 'ג\'וליס', district: 'הצפון' },
  { id: 'yanuh-jat', name: 'ינוח-ג\'ת', district: 'הצפון' },
  { id: 'kisra-sumei', name: 'כסרא-סמיע', district: 'הצפון' },
  { id: 'sajur', name: 'סג\'ור', district: 'הצפון' },
  { id: 'beit-jann', name: 'בית ג\'ן', district: 'הצפון' },
  { id: 'ein-al-asad', name: 'עין אל-אסד', district: 'הצפון' },
  
  // מועצות אזוריות - יישובים נבחרים
  { id: 'migdal-haemek', name: 'מגדל העמק', district: 'הצפון' },
  { id: 'afula', name: 'עפולה', district: 'הצפון' },
  { id: 'beit-shean', name: 'בית שאן', district: 'הצפון' },
  { id: 'yavneel', name: 'יבנאל', district: 'הצפון' },
  { id: 'hazor-haglilit', name: 'חצור הגלילית', district: 'הצפון' },
  { id: 'rosh-pina', name: 'רוש פינה', district: 'הצפון' },
  { id: 'metula', name: 'מטולה', district: 'הצפון' },
  { id: 'kiryat-tivon', name: 'קריית טבעון', district: 'חיפה' },
  { id: 'nesher', name: 'נשר', district: 'חיפה' },
  { id: 'tirat-carmel', name: 'טירת כרמל', district: 'חיפה' },
  
  // כפרים ויישובים קטנים נוספים
  { id: 'kaukab-abu-al-hija', name: 'כוכב אבו אל-היג\'א', district: 'הצפון' },
  { id: 'mashad', name: 'משהד', district: 'הצפון' },
  { id: 'dabburiya', name: 'דבוריה', district: 'הצפון' },
  { id: 'shibli-umm-al-ghanam', name: 'שבלי-אום אל-גנם', district: 'הצפון' },
  { id: 'bina', name: 'בענה', district: 'הצפון' },
  { id: 'nahaf', name: 'נחף', district: 'הצפון' },
  { id: 'rame', name: 'רמה', district: 'הצפון' },
  { id: 'fassuta', name: 'פסוטה', district: 'הצפון' },
  { id: 'miilya', name: 'מעיליא', district: 'הצפון' },
  { id: 'tarshiha', name: 'תרשיחא', district: 'הצפון' },
  { id: 'sulam', name: 'סולם', district: 'הצפון' },
  { id: 'sandala', name: 'סנדלה', district: 'הצפון' },
  { id: 'kafr-misr', name: 'כפר מצר', district: 'הצפון' },
  { id: 'khwalid', name: 'חואלד', district: 'הצפון' },
  { id: 'bi-nah', name: 'בי\'נה', district: 'הצפון' },
  { id: 'rama', name: 'ראמה', district: 'הצפון' },
  { id: 'i-billin', name: 'אבלין', district: 'הצפון' },
  { id: 'shajur', name: 'שג\'ור', district: 'הצפון' },
  { id: 'kafr-sumei', name: 'כפר סומי', district: 'הצפון' },
].sort((a, b) => a.name.localeCompare(b.name, 'he'));
